module.exports = __webpack_public_path__ + "img/drawfree.197233e0.png";